export default __webpack_public_path__ + "static/media/textlab_logo.6afcb86c.png";